import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Link } from "@material-ui/core";
import { getAUAIcon, scrollTop } from "../common";
import "../styles/masterStyles.css";
import { isTablet } from "react-device-detect";

const scrollThis = (id, offset) => {
    if (typeof id === 'undefined') { id = 'root'; }
    if (typeof offset === 'undefined') { offset = 54; }

    // console.log(`scroll to ${id} | offset: ${offset}`)
    return document.getElementById(`${id}`).scrollIntoView({
        behavior: 'smooth', // optional
        block: 'start'      // aligns to top of viewport
    });
}

const ScrollTopWidget = props => { 
    // console.log(props)
    const [id] = useState(props.target ? props.target : 'root');
    const [offset] = useState(props.offset ? props.offset : 0);

    return (
        <div className="scroll-top-widget">
            <Link
                onClick={() => {
                    // console.log(`id: ${id} \noffset: ${offset}`)
                    return scrollThis(id, offset)}
                }
            >
                {getAUAIcon('AUAUpArrow')}
            </Link>
        </div>
    )
};

const mapStateToProps = state => {
    const { auth, user_details } = state.auth;
    return { auth, user_details };
};

const ScrollTopWidgetCard = connect(mapStateToProps)(withRouter(ScrollTopWidget));

export { ScrollTopWidgetCard }